<template>
    <div class="page">

        <div class="container px-11 lg:px-3 m-auto">
            PageDefault
            {{ currentPage }}
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";

export default {
    name: "PageDefault",
     mixins:[PagesMixin],
}
</script>

<style scoped lang="scss">

</style>
